module.exports = __webpack_public_path__ + "media/images/athletes/16-92025bd2df94991bc3a193df1cc0771e.png";